// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    "Plan Your Soulful Yatra Trip": "Plan Your Soulful Yatra Trip",
                    "Destination:": "Destination:",
                    "Number of Days:": "Number of Days:",
                    "Interests (optional, comma-separated):": "Interests (optional, comma-separated):",
                    "Enter city or place": "Enter city or place",
                    "e.g., spiritual, nature, adventure": "e.g., spiritual, nature, adventure",
                    "Generate Itinerary": "Generate Itinerary",
                    "Your Personalized Travel Plan": "Your Personalized Travel Plan",
                    "Save Trip": "Save Trip",
                    "Choose Language:": "Choose Language:",
                    "Day": "Day",
                    "Generating itinerary...": "Generating itinerary..."
                },
            },
            hi: {
                translation: {
                    "Plan Your Soulful Yatra Trip": "अपनी सोलफुल यात्रा की योजना बनाएं",
                    "Destination:": "गंतव्य:",
                    "Number of Days:": "दिनों की संख्या:",
                    "Interests (optional, comma-separated):": "रुचियां (वैकल्पिक, कॉमा से अलग):",
                    "Enter city or place": "शहर या स्थान दर्ज करें",
                    "e.g., spiritual, nature, adventure": "जैसे, आध्यात्मिक, प्रकृति, साहसिक",
                    "Generate Itinerary": "यात्रा योजना बनाएं",
                    "Your Personalized Travel Plan": "✨ आपकी व्यक्तिगत यात्रा योजना ✨",
                    "Save Trip": "यात्रा सहेजें",
                    "Choose Language:": "भाषा चुनें:",
                    "Day": "दिन",
                    "Generating itinerary...": "यात्रा योजना बनाई जा रही है..."
                },
            },
            // Add more (te, ta, kn) here
        },
        lng: "en", // default language
        fallbackLng: "en",
        interpolation: {
            escapeValue: false, // react already escapes
        },
    });

export default i18n;
